import { render, staticRenderFns } from "./DiscountModal.vue?vue&type=template&id=2feb5cc2&scoped=true&"
import script from "./DiscountModal.vue?vue&type=script&lang=js&"
export * from "./DiscountModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2feb5cc2",
  null
  
)

export default component.exports